import { render, staticRenderFns } from "./groupTrans.vue?vue&type=template&id=b40c0b2c"
import script from "./groupTrans.vue?vue&type=script&lang=js"
export * from "./groupTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports